import React, { useState } from 'react';
import logo from '../../assets/logo.png';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { adminBaseUrl } from '../../utils/baseUrl';
import Cookies from 'js-cookie';

const Form = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const validateForm = () => {
        if (!email || !password) {
            toast.error("Email and Password are required!");
            return false;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            toast.error("Invalid email format!");
            return false;
        }
        if (password.length < 6) {
            toast.error("Password must be at least 6 characters!");
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setLoading(true);

        try {
            // Call your login API
            const response = await fetch(`${adminBaseUrl}/admin/sign-in`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password }),
            });

            const data = await response.json();

            if (response.ok) {
                toast.success("Login successful!");
                setTimeout(() => {
                    window.location.reload();
                }, 500);

                navigate('/')
                Cookies.set("token", data.token, { expires: 7 });
            } else {
                toast.error(data.message || "Invalid credentials!");
            }
        } catch (error) {
            console.log("errrr", error)
            toast.error("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex h-screen overflow-hidden">
            {/* Left side with asset */}
            <div className="w-[60%] bg-white items-center justify-center hidden md:flex">
                <img src="https://img.freepik.com/free-photo/observation-urban-building-business-steel_1127-2397.jpg" alt="Asset" className="w-full h-full" />
            </div>

            {/* Right side with login card */}
            <div className="w-full md:w-[40%] flex bg-white items-center justify-center">
                <div className="bg-white p-8 rounded-lg w-[80%]">
                    {/* Logo */}
                    <div className="mb-8">
                        <img src={logo} alt="Logo" className="w-1/2 mx-auto" />
                    </div>

                    <div className="text-black text-center text-2xl font-bold">
                        Login to your account
                    </div>

                    {/* Login form */}
                    <form className="mt-5" onSubmit={handleSubmit}>
                        <input
                            type="email"
                            placeholder="Email"
                            className="w-full bg-white text-[#8E8E8E] rounded px-4 py-3 border border-[#BABABA]"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />

                        <input
                            type="password"
                            placeholder="Password"
                            className="w-full bg-white text-[#8E8E8E] rounded px-4 py-3 mt-6 border border-[#BABABA]"
                            name="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full mt-5 bg-gradient-to-r from-[#FFBE00] to-[#BA5B00] hover:bg-amber-600 text-white font-bold py-3 px-4 rounded focus:outline-none focus:shadow-outline disabled:opacity-50"
                        >
                            {loading ? "Logging in..." : "Login"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Form;
